// import {useQuery, gql} from "@apollo/client";

import {EditDeleteButtons} from "./Admin";
import ReactMarkdown from "react-markdown";
import ToDoList from "./ToDoList";
import CloudImg from "./CloudImg";
import blogposts from './blogposts.json';


{/*
const BLOG_POSTS = gql `
    query GetPosts {
        posts{
            title
            id
            date
            body
        }
    }
`
*/}

export default function Blog(props) { 

{/*
  const {loading,error,data} = useQuery(BLOG_POSTS);
  if (loading) return <p>Loading blog posts from database</p>;
  if (error) {
    console.log(error);
    return <p>Error</p>;
  }

*/}

  const orderedPosts = [...blogposts.data.posts].reverse().map((post) => (
    <div key={post.id}>
      <BlogPost admin={props.admin} {...post} />
    </div>
  ));

  return (
    <div className="centerBox">
      <ToDoList />
      <div className="blogContainer">
        {orderedPosts}
      </div>
    </div>
  );

}

const BlogPost = (props) => {

  function handleEdit(e){
    e.preventDefault();
    console.log("Edit.");
  }
  function handleDelete(e) {
    e.preventDefault();
    console.log("Delete.");
  }

  return(
    <article className="blogpost">
      <div className="postTitle">{props.title}</div>
      <em>{new Date(props.date).toDateString()}</em><br/>
      <ReactMarkdown components={{img:CloudImg}}>{props.body}</ReactMarkdown>
      <div>{props.admin ? <EditDeleteButtons id={props.id}/>:"" }</div>
    </article>
  );
}

const TestPost = () => {
  const thisPost = {
    title: "Test",
    date: 1,
    body: "Test ![Alt prop](profile.jpg)"
  };
  return <BlogPost {...thisPost} />
}

export {Blog, BlogPost};
